/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

//==============================================================
// START Enums and Input Objects
//==============================================================

export enum BlockedAccessSubjectType {
  GROUP = "GROUP",
  USER = "USER",
}

export enum ResourceAccessType {
  EDIT = "EDIT",
  VIEW = "VIEW",
}

export enum ResourceType {
  DATABASE = "DATABASE",
  FOLDER = "FOLDER",
  PAGE = "PAGE",
  SPACE = "SPACE",
  WHITEBOARD = "WHITEBOARD",
}

export enum SpaceRoleType {
  CUSTOM = "CUSTOM",
  SYSTEM = "SYSTEM",
}

export interface BlockedAccessSubjectInput {
  subjectId: string;
  subjectType: BlockedAccessSubjectType;
}

//==============================================================
// END Enums and Input Objects
//==============================================================

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: BlockedAccessRestrictionsQuery
// ====================================================

export interface BlockedAccessRestrictionsQuery_blockedAccessRestrictions_blockedAccessRestrictionSummary_subject {
  subjectId: string;
  subjectType: BlockedAccessSubjectType;
}

export interface BlockedAccessRestrictionsQuery_blockedAccessRestrictions_blockedAccessRestrictionSummary_restrictedResources_resourceLink {
  base: string | null;
  webUi: string | null;
}

export interface BlockedAccessRestrictionsQuery_blockedAccessRestrictions_blockedAccessRestrictionSummary_restrictedResources {
  resourceId: any;
  resourceTitle: string;
  resourceLink: BlockedAccessRestrictionsQuery_blockedAccessRestrictions_blockedAccessRestrictionSummary_restrictedResources_resourceLink;
  requiredAccessType: ResourceAccessType | null;
  resourceType: ResourceType;
}

export interface BlockedAccessRestrictionsQuery_blockedAccessRestrictions_blockedAccessRestrictionSummary {
  subject: BlockedAccessRestrictionsQuery_blockedAccessRestrictions_blockedAccessRestrictionSummary_subject | null;
  restrictedResources: (BlockedAccessRestrictionsQuery_blockedAccessRestrictions_blockedAccessRestrictionSummary_restrictedResources | null)[] | null;
}

export interface BlockedAccessRestrictionsQuery_blockedAccessRestrictions_blockedAccessEmpowerment {
  subjectId: string;
  isCurrentUserEmpowered: boolean;
}

export interface BlockedAccessRestrictionsQuery_blockedAccessRestrictions_blockedAccessAssignableSpaceRolesIntersection {
  roleId: string;
  roleDescription: string;
  roleName: string;
  roleType: SpaceRoleType;
}

export interface BlockedAccessRestrictionsQuery_blockedAccessRestrictions {
  blockedAccessRestrictionSummary: (BlockedAccessRestrictionsQuery_blockedAccessRestrictions_blockedAccessRestrictionSummary | null)[];
  blockedAccessEmpowerment: (BlockedAccessRestrictionsQuery_blockedAccessRestrictions_blockedAccessEmpowerment | null)[];
  blockedAccessAssignableSpaceRolesIntersection: (BlockedAccessRestrictionsQuery_blockedAccessRestrictions_blockedAccessAssignableSpaceRolesIntersection)[];
  canFixRestrictionsForAllSubjects: boolean;
}

export interface BlockedAccessRestrictionsQuery {
  blockedAccessRestrictions: BlockedAccessRestrictionsQuery_blockedAccessRestrictions;
}

export interface BlockedAccessRestrictionsQueryVariables {
  accessType: ResourceAccessType;
  contentId: any;
  subjects: (BlockedAccessSubjectInput | null)[];
}
